(() => {
  'use strict';
  const dialog = document.getElementById('bcm-question-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const select = dialog.querySelector('[name="contact[preferred_showroom]"]');
  const showrooms = { foscoe: 'Foscoe', boone_mall: 'Inside the Boone Mall' };
  let opener;
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    let url;
    try { url = new URL(link.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin || url.pathname !== '/pages/contact-us' || url.hash !== '#send-a-message') return;
    if (dialog.open) return;
    const showroom = url.searchParams.get('showroom');
    if (select && Object.prototype.hasOwnProperty.call(showrooms, showroom)) select.value = showrooms[showroom];
    event.preventDefault();
    opener = link;
    dialog.showModal();
    document.documentElement.classList.add('bcm-question-open');
  });
  dialog.querySelector('[data-bcm-question-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('submit', () => dialog.close(), true);
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('bcm-question-open');
    if (opener && opener.isConnected) opener.focus();
  });
})();
